// ======================================================================
// 📁 File: src/modules/ppe/components/engineering/product-family/ProductFamilyKpiBar.js
// 📝 Purpose:
//   KPI bar for Product Family Master
//   KPIs:
//   [ Total ] [ Active ] [ Inactive ] [ With Variants ] [ Without Variants ] [ Used in Orders ]
//   - ERP-grade, read-only indicators
//   - Reusable pattern for other masters
// ======================================================================

import React from "react";
import KpiCard from "../../common/KpiCard";

export default function ProductFamilyKpiBar({ rows = [] }) {
  const total = rows.length;

  const active = rows.filter((r) => r.is_active === 1).length;
  const inactive = rows.filter((r) => r.is_active === 0).length;

  const withVariants = rows.filter((r) => (r.variant_count || 0) > 0).length;
  const withoutVariants = total - withVariants;

  const usedInOrders = rows.filter((r) => r.used_in_orders === true).length;

  return (
    <div
      style={{
        display: "flex",
        gap: 16,
        marginBottom: 20,
        flexWrap: "wrap",
      }}
    >
      <KpiCard
        title="Total"
        value={total}
        color="#6366f1"
        icon="fas fa-layer-group"
      />

      <KpiCard
        title="Active"
        value={active}
        color="#16a34a"
        icon="fas fa-check-circle"
      />

      <KpiCard
        title="Inactive"
        value={inactive}
        color="#dc2626"
        icon="fas fa-times-circle"
      />

      <KpiCard
        title="With Variants"
        value={withVariants}
        color="#7c3aed"
        icon="fas fa-cubes"
      />

      <KpiCard
        title="Without Variants"
        value={withoutVariants}
        color="#f59e0b"
        icon="fas fa-exclamation-triangle"
      />

      <KpiCard
        title="Used in Orders"
        value={usedInOrders}
        color="#0284c7"
        icon="fas fa-link"
      />
    </div>
  );
}
